fragment LocalizedStringFull on LocalizedString {
  cs
}
